import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function ShopPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products").then(r => setProducts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="shop-page" className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-24">
      <div className="mb-12 md:mb-16">
        <div className="overline">Collection</div>
        <h1 className="font-serif text-5xl md:text-6xl mt-3 tracking-tighter">All pieces</h1>
        <p className="text-brand-muted mt-4 max-w-xl">Made in small batches. Each silhouette honors the print it carries.</p>
      </div>

      {loading && <div className="text-center py-20 text-brand-muted">Loading…</div>}
      {!loading && products.length === 0 && (
        <div className="text-center py-20 text-brand-muted">No products yet — check back soon.</div>
      )}

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
        {products.map((p, idx) => (
          <Link
            key={p.id}
            to={`/product/${p.id}`}
            data-testid={`shop-product-${p.id}`}
            className="group cursor-pointer animate-fade-up"
            style={{ animationDelay: `${idx * 60}ms` }}
          >
            <div className="aspect-[3/4] overflow-hidden bg-brand-bg2 relative">
              <img src={p.image} alt={p.name} className="product-img w-full h-full object-cover" />
              {!p.in_stock && (
                <div className="absolute top-3 left-3 bg-brand-ink text-brand-bg text-[10px] tracking-[0.2em] uppercase px-3 py-1.5">
                  Sold out
                </div>
              )}
            </div>
            <div className="mt-4">
              <h3 className="font-serif text-lg leading-tight">{p.name}</h3>
              <div className="text-sm text-brand-muted mt-1">£{p.price.toFixed(2)}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
